<template>
    <div class="check-container">
        <div class="check-container-title">
            为保证您的信息安全，请先验证身份
        </div>
        <send-sms
            ref="sendSmsRef"
            @emit-on-click-send-sms="onClickSendSms"
            @emit-on-input-sms="onInputSms"
        ></send-sms>
        <div class="check-container-tip">
            验证码将通过短信发送至+86 {{ checkPhone }}
        </div>
        <div class="check-container-btn" :class="disabled ? 'disabled-btn' : ''">
            <sp-button
                type="primary"
                @click="onLogin"
            >
                {{ btnDesc }}
            </sp-button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { Button } from '@ks/sharp-ui';
import { postLoginBySms, postSendSms, saveDraft } from '@/utils/fetch';
import localCache from '@/utils/cache';
import { setPageTitle } from '@/utils/bridge';
import { toast } from '@/utils/toast';
import throttle from 'lodash/throttle';
import SendSms from '@/components/SendSms/SendSms';

export default {
    name: 'check',
    components: {
        [Button.name]: Button,
        SendSms,
    },
    data() {
        return {
            sms: '',
            onClickSendSms: throttle(this.requestSendSms, 500, {
                leading: true,
                trailing: false,
            }),
            btnDesc: '验证',
        };
    },
    computed: {
        ...mapState(['checkPhone', 'currentBizKey', 'from']),
        ...mapGetters(['currentPageTitle', 'bizConfig']),
        disabled() {
            return !this.sms || this.sms.length < 6;
        },
    },
    methods: {
        ...mapMutations(['saveTicket']),
        ...mapActions(['setPageInfo']),
        setPageTitle,
        async onLogin() {
            try {
                this.btnDesc = '验证中';
                const res = await postLoginBySms({
                    from: this.from,
                    bizKey: this.currentBizKey,
                    verify: this.sms,
                });
                if (res.result !== 1) {
                    toast(res.error_msg);
                    this.btnDesc = '验证';
                    return;
                }
                this.saveTicket({
                    code: 0,
                    soid: '',
                });
                // 【草稿互通】验真成功后，将 localStorage 最新数据同步到服务端草稿
                // 保证 setPageInfo → getDraft 读到的是最新数据，避免旧服务端草稿覆盖本地缓存
                const cacheKey = `cacheKey_${this.currentBizKey}_${this.from || 'default'}`;
                const latestLocalData = localCache.get(cacheKey);
                if (latestLocalData && Object.keys(latestLocalData).length > 0) {
                    try {
                        await saveDraft({ bizKey: this.currentBizKey, from: this.from, data: latestLocalData });
                    } catch (e) {
                        // 静默降级，不阻塞后续初始化流程
                        // console.warn('[check-saveDraft] 验真后同步草稿失败，继续初始化', e);
                    }
                }
                this.setPageInfo({});

            } catch (error) {
                this.btnDesc = '验证';
                console.error(`An error occurred while: ${postLoginBySms}`, error);
                toast(error.message);
            }
        },

        onInputSms(sms) {
            this.sms = sms;
        },
        async requestSendSms($sms) {
            try {
                this.sms = $sms;
                const res = await postSendSms({
                    from: this.from,
                    bizKey: this.currentBizKey,
                });
                if (res.result !== 1) {
                    toast(res.error_msg);
                    this.$refs.sendSmsRef.resetCountDown();
                    return;
                }
            } catch (error) {
                console.error(`An error occurred while: ${postLoginBySms}`, error);
                toast(error.message);
                this.$refs.sendSmsRef.resetCountDown();
            }
        },
    },
    watch: {
        currentPageTitle: {
            immediate: true,
            handler: 'setPageTitle',
        },
    },
};
</script>
<style lang='less' scoped>
.check-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 19px;

    &-title {
        font-size: 18px;
        color: #222;
        font-weight: 500;
        line-height: 25px;
    }

    &-tip {
        margin-top: 8px;
        color: #9c9c9c;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px /* 150% */;
    }

    &-btn {
        margin-top: 36px;
    }
}
.disabled-btn {
    opacity: 0.5;
    pointer-events: none;
}
</style>
